/***************************************************************************************************
** isValueBlank
***************************************************************************************************/

const BLANK_STRING_VALUES = ["null", "undefined", ""];

export default function isValueBlank(value) {
  if (value === null || value === undefined) return true;

  return BLANK_STRING_VALUES.includes(String(value).trim());
}
